module.exports = __webpack_public_path__ + "img/A88C77_DAD2C7_623532_956229-256px.61c2a9b2.png";